import React, { useRef } from "react";
import { ReactComponent as SearchIcon } from "./../../images/svg/search.svg";
import { gettext } from "../../adapter";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

const FilterSearch = ({ search }) => {
  const inputRef = useRef();
  const location = useLocation();
  const history = useHistory();
  var query = queryString.parse(location.search);

  const onSearch = (event) => {
    event.preventDefault();
    var search = inputRef.current.value.trim();
    if (search !== "") {
      query.q = search;
    } else {
      delete query.q;
    }
    history.push("?" + queryString.stringify(query));
  };

  return (
    <div className="search">
      <input
        onChange={onSearch}
        defaultValue={query.q}
        ref={inputRef}
        type="search"
        placeholder={gettext("Filter by name")}
        tabIndex="1"
      />
      <SearchIcon />
    </div>
  );
};

export default FilterSearch;
